/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style4 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style5 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style6 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _reactRouter = require('react-router');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _tool = require('util/tool');

var _config = require('util/config');

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = _button2.default.Group;

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.onChange = function (pagination, filters, sorter) {
      _this.setState({
        page: pagination.current,
        sort: sorter.order && (sorter.order.indexOf('des') > -1 ? 'desc' : 'asc') || '',
        sortKey: sorter.field || ''
      }, function () {
        _this.fetch();
      });
    };

    _this.search = function (o) {
      _this.setState({
        keywords: o.keyWord,
        page: 1
      }, function () {
        _this.fetch();
      });
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //   }
      // });
    };

    _this.state = {
      page: 1,
      records: [],
      keywords: '',
      upgradeStatus: 0,
      lastTime: '00:00',
      productTemplate: null
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'updateRoute',
    value: function updateRoute(id) {
      this.props.router.push({
        pathname: '/remote/' + id + '/update'
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const {params} = this.props
      // let options = {productId: params.id}
      this.getProductTemplate();
      this.fetch();
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this2 = this;

      var _state = this.state,
          page = _state.page,
          keywords = _state.keywords,
          upgradeStatus = _state.upgradeStatus;
      var params = this.props.params;
      var id = params.id,
          rid = params.rid;

      var sendData = {
        page: page,
        serialNumber: keywords,
        //productId: id,
        productUpgradeId: rid
      };
      if (upgradeStatus > 0) {
        sendData.deviceUpgradeStatus = upgradeStatus;
      }
      (0, _tool.http)(_config.apiJson.getPageDeviceUpgradeList, sendData).then(function (res) {
        _this2.setState({
          records: res
        });
        if (res.rows.length > 0 && upgradeStatus == 1) {
          _this2.getTime(res.rows[0].upgradeTime);
        }
      });
    }
  }, {
    key: 'getTime',
    value: function getTime(str) {
      var tmpArr = str.split(" ");
      var str1 = tmpArr[0];
      var str2 = tmpArr[1];
      var tmpArr1 = str1.split("-");
      var tmpArr2 = str2.split(":");
      var d1 = new Date(tmpArr1[0], tmpArr1[1] - 1, tmpArr1[2], tmpArr2[0], tmpArr2[1], tmpArr2[2]);
      var d2 = new Date();
      var seconds = parseInt((d1.getTime() - d2.getTime()) / 1000);
      if (seconds > 0) {
        var h = parseInt(seconds / 3600);
        var s = parseInt((seconds - h * 3600) / 60);
        this.setState({
          lastTime: this.returnStr(h) + ":" + this.returnStr(s)
        });
      } else {
        this.setState({
          lastTime: "00:00"
        });
      }
    }
  }, {
    key: 'returnStr',
    value: function returnStr(str) {
      if (str < 10) {
        str = "0" + str;
      }
      return str;
    }
  }, {
    key: 'changeState',
    value: function changeState(state) {
      var _this3 = this;

      this.setState({
        upgradeStatus: state
      }, function () {
        _this3.fetch();
      });
    }
  }, {
    key: 'getProductTemplate',
    value: function getProductTemplate() {
      var _this4 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this4.setState({
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: 'ReUpgrade',
    value: function ReUpgrade() {
      var _props$params = this.props.params,
          id = _props$params.id,
          rid = _props$params.rid;
      var total = this.state.records.total;

      if (total > 0) {
        this.props.router.push({
          pathname: '/remote/' + id + '/reupgrad/' + rid
        });
      } else {
        _message2.default.warning("没有升级失败的设备");
      }
    }
  }, {
    key: 'cancelTask',
    value: function cancelTask() {
      var _this5 = this;

      var rid = this.props.params.rid;
      var total = this.state.records.total;

      if (total > 0) {
        var sendData = {
          recordId: rid
        };
        (0, _tool.http)(_config.apiJson.cancelProductUpgradeTask, sendData).then(function (res) {
          if (res == true) {
            _message2.default.success("取消定时任务成功");
          } else {
            _message2.default.error("取消定时任务失败");
          }
          _this5.fetch();
        });
      } else {
        _message2.default.warning("没有可取消升级的设备");
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var params = this.props.params;
      var _state2 = this.state,
          records = _state2.records,
          upgradeStatus = _state2.upgradeStatus,
          lastTime = _state2.lastTime,
          page = _state2.page,
          productTemplate = _state2.productTemplate;

      var list = records;
      var status = {
        1: '待升级',
        2: '升级中',
        3: '升级成功',
        4: '升级失败'
      };

      var color = {
        1: "blue",
        2: "blue",
        3: "green",
        4: "red"
      };

      var pagination = {
        defaultCurrent: 1,
        current: page,
        total: list.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return '\u5171\u8BA1 ' + total + ' \u6761';
        },
        showQuickJumper: true
      };

      var columns = [{
        title: '设备信息',
        dataIndex: 'serialNumber',
        width: 300,
        render: function render(text, record) {
          return (0, _jsx3.default)('div', {
            className: 'td-info'
          }, void 0, (0, _jsx3.default)('p', {}, void 0, 'SN\u53F7\uFF1A', record.serialNumber || '--'));
        }
      }, {
        title: '操作时间',
        dataIndex: 'upgradeTime'
      }, {
        title: '升级状态',
        dataIndex: 'upgradeStatus',
        width: 200,
        // sorter: (a, b) => a.upgradeStatus - b.upgradeStatus,
        render: function render(text, record) {
          return (0, _jsx3.default)('div', {
            className: 'td-info fail'
          }, void 0, (0, _jsx3.default)('p', {
            className: color[text]
          }, void 0, status[text]), text == 4 ? (0, _jsx3.default)('p', {
            className: 'reason'
          }, void 0, record.failReason) : '');
        }
      }, {
        title: '更新版本号',
        dataIndex: 'versionCode',
        render: function render(text, record) {
          return '' + text;
        }
      }, {
        title: '推送时间',
        dataIndex: 'createTime',
        render: function render(text) {
          return text || '--';
        }
      }, {
        title: '操作员',
        dataIndex: 'creator',
        render: function render(text) {
          return text || '--';
        }
      }];

      var data = [];
      var rows = list.rows ? list.rows : [];

      rows.map(function (item, index) {
        var o = {
          key: index,
          serialNumber: item.serialNumber,
          upgradeTime: item.upgradeTime,
          upgradeTimeStr: _tool.tool.formatTime(item.upgradeTime.replace(/\-/g, '/')),
          upgradeMode: item.upgradeMode,
          versionCode: item.versionCode,
          upgradeRange: item.upgradeRange,
          packageVerifyValue: item.packageVerifyValue,
          remark: item.remark,
          createTime: _tool.tool.formatTime(item.createTime.replace(/\-/g, '/')),
          creator: item.creator,
          failReason: item.failReason,
          deviceId: item.deviceId,
          upgradeStatus: item.upgradeStatus
        };

        data.push(o);
      });
      return (0, _jsx3.default)('div', {
        className: 'remote-records'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'search'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'btn-list'
      }, void 0, (0, _jsx3.default)(ButtonGroup, {}, void 0, (0, _jsx3.default)(_button2.default, {
        type: upgradeStatus == 0 ? "primary" : "",
        onClick: this.changeState.bind(this, 0)
      }, void 0, productTemplate === 1 ? '全部车辆' : '全部设备'), (0, _jsx3.default)(_button2.default, {
        type: upgradeStatus == 4 ? "primary" : "",
        onClick: this.changeState.bind(this, 4)
      }, void 0, productTemplate === 1 ? '升级失败车辆' : '升级失败设备'))), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_button2.default, {
        className: 'reset',
        type: 'primary',
        style: { display: upgradeStatus == 4 ? "block" : "none" },
        onClick: this.ReUpgrade.bind(this)
      }, void 0, '\u91CD\u65B0\u5347\u7EA7'), (0, _jsx3.default)(_search2.default, {
        onSubmit: this.handleSubmit.bind(this),
        search: this.search,
        message: '\u8F93\u5165\u8BBE\u5907\u5E8F\u5217\u53F7\u641C\u7D22'
      }))), (0, _jsx3.default)('div', {
        className: 'remote-time',
        style: { display: upgradeStatus == 1 ? "block" : "none" }
      }, void 0, (0, _jsx3.default)('p', {}, void 0, '\u8DDD\u79BB\u5347\u7EA7\u65F6\u95F4\uFF1A', (0, _jsx3.default)('span', {}, void 0, lastTime)), (0, _jsx3.default)(_button2.default, {
        onClick: this.cancelTask.bind(this)
      }, void 0, '\u53D6\u6D88\u5347\u7EA7')), (0, _jsx3.default)(_table2.default, {
        className: 'list',
        columns: columns,
        dataSource: data,
        pagination: pagination,
        onChange: this.onChange
      }));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: '', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "detail.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/records/detail.jsx
// module id = 1509
// module chunks = 0